var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationBookingIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.10164 13.6787L5.59212 10.4917C5.55329 10.2466 5.11367 9.54939 4.88221 9.47868L1.84687 8.54951C0.63988 8.18115 -0.0637874 6.91982 0.004562 5.59106C0.071358 4.2623 0.916401 3.18025 2.13582 2.85957L12.6632 0.0885701C13.6838 -0.179483 14.6919 0.169139 15.3676 1.02263C16.0418 1.87613 16.1863 2.99112 15.756 4.00578L11.4142 14.2395C10.9094 15.4301 9.79249 16.1142 8.56686 15.9843C7.34123 15.8544 6.30669 14.9647 6.10164 13.6787Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationBookingIcon);
export default __webpack_public_path__ + "static/media/LocationBookingIcon.c365a187f03a1b63064a4267228199d4.svg";
export { ForwardRef as ReactComponent };